import React, { Dispatch, ReactElement, SetStateAction } from 'react';
import { Row } from '@op/opds.opux';
import { Slider } from '@op/opds.opux-slider';
import { Message, useMessage } from '@messageformat/react';

interface Props {
  savingAmount: number;
  initialSaving: number;
  savingTime: number;
  profitExpectation: number;
  setSavingAmount: Dispatch<SetStateAction<number>>;
  setInitialSaving: Dispatch<SetStateAction<number>>;
  setSavingTime: Dispatch<SetStateAction<number>>;
  setProfitExpectation: Dispatch<SetStateAction<number>>;
}

const ProfitSlider = (props: Props): ReactElement => {
  const {
    savingAmount,
    initialSaving,
    savingTime,
    profitExpectation,
    setSavingAmount,
    setInitialSaving,
    setSavingTime,
    setProfitExpectation,
  } = props;

  const amountLabel = useMessage('course4.question3.monthly_saving').split(' ')[0];
  const initialLabel = useMessage('course4.question3.initial_saving').split(' ')[0];
  const timeLabel = useMessage('course4.question3.saving_time').split(' ')[0];
  const rateLabel = useMessage('course4.question3.saving_rate').split(' ')[0];

  const handleChange = (setAmount: React.Dispatch<React.SetStateAction<number>>) => {
    return (value: number | number[]) => {
      setAmount(value as number);
    };
  };

  return (
    <div className="investoracademy-slider-column">
      <Row id="monthly-saving" className="investoracademy-slider-row">
        <div
          className="opds-styles-v1-text-title-small-strong"
          style={{ textAlign: 'center', alignSelf: 'stretch' }}
        >
          <Message id="course4.question3.monthly_saving" value={savingAmount} />
        </div>
        <div className="investoracademy-slider">
          <Slider
            aria-label={amountLabel}
            defaultValue={savingAmount}
            step={50}
            min={0}
            max={1000}
            size="default"
            onChange={handleChange(setSavingAmount)}
          />
        </div>
      </Row>
      <div className="investoracademy-profit-column-line" />
      <Row id="initial-saving" className="investoracademy-slider-row">
        <div
          className="opds-styles-v1-text-title-small-strong"
          style={{ textAlign: 'center', alignSelf: 'stretch' }}
        >
          <Message id="course4.question3.initial_saving" value={initialSaving} />
        </div>
        <div className="investoracademy-slider">
          <Slider
            aria-label={initialLabel}
            defaultValue={initialSaving}
            step={100}
            min={0}
            max={5000}
            size="default"
            onChange={handleChange(setInitialSaving)}
          />
        </div>
      </Row>
      <div className="investoracademy-profit-column-line" />
      <Row id="saving-time" className="investoracademy-slider-row">
        <div
          className="opds-styles-v1-text-title-small-strong"
          style={{ textAlign: 'center', alignSelf: 'stretch' }}
        >
          <Message id="course4.question3.saving_time" value={savingTime} />
        </div>
        <div className="investoracademy-slider">
          <Slider
            aria-label={timeLabel}
            defaultValue={savingTime}
            step={1}
            min={1}
            max={30}
            size="default"
            onChange={handleChange(setSavingTime)}
          />
        </div>
      </Row>
      <div className="investoracademy-profit-column-line" />
      <Row id="saving-rate" className="investoracademy-slider-row">
        <div
          className="opds-styles-v1-text-title-small-strong"
          style={{ textAlign: 'center', alignSelf: 'stretch' }}
        >
          <Message id="course4.question3.saving_rate" value={profitExpectation} />
        </div>
        <div className="investoracademy-slider">
          <Slider
            aria-label={rateLabel}
            defaultValue={profitExpectation}
            step={1}
            min={0}
            max={10}
            size="default"
            onChange={handleChange(setProfitExpectation)}
          />
        </div>
      </Row>
    </div>
  );
};

export default ProfitSlider;
